import React from 'react';
import { useSelector } from 'react-redux';
import { site, dialogs } from '@yola/ws-sdk';
import { DifmButton } from '@yola/webapp-plugins';
import segment from '../../analytics/segment';
import config from '../../config';
import dialogTypes from '../../dialogs/constants/dialog-types';
import { hasGoldSubscriptionWithDifmPromo } from '../verifiers/has-gold-subscription';
import isDifmOrderSubmitted from '../verifiers/is-difm-order-submitted';

const {
  constants: { triggerIds, events },
  trackers: { trackEvent },
} = segment;

const DifmButtonContainer = () => {
  const businessCategory = useSelector(site.selectors.getBusinessCategory);
  const helpCenterConfig = useSelector(config.selectors.getHelpCenterConfig);

  const isOrderSubmitted = isDifmOrderSubmitted();
  const isGoldWithDifmPromo = hasGoldSubscriptionWithDifmPromo();
  const isChangeRequestFlow = isGoldWithDifmPromo && isOrderSubmitted;
  const isOrderFormFlow = isGoldWithDifmPromo && !isOrderSubmitted;

  const handleDifmButtonClick = () => {
    if (isChangeRequestFlow) {
      trackEvent(events.DIFM_CHANGE_REQUEST_BUTTON_CLICKED, {
        businessCategory,
        triggerId: triggerIds.EDITOR_HEADER,
      });

      // Since we use href to redirect to help center, we don't need to show any dialogs
      return;
    }

    if (isOrderFormFlow) {
      trackEvent(events.DIFM_BUTTON_CLICKED, {
        businessCategory,
        triggerId: triggerIds.EDITOR_HEADER,
      });

      dialogs.operations.show(dialogTypes.DIFM_ORDER_FORM_DIALOG);
      return;
    }

    trackEvent(events.DIFM_BUTTON_CLICKED, {
      businessCategory,
      triggerId: triggerIds.EDITOR_HEADER,
    });

    dialogs.operations.show(dialogTypes.DIFM_UPSELL_DIALOG);
  };

  return (
    <DifmButton
      {...(isChangeRequestFlow && {
        href: helpCenterConfig.nn_difm_request_changes_url,
      })}
      isAnimated={!isGoldWithDifmPromo}
      withPopover={isChangeRequestFlow}
      onClick={handleDifmButtonClick}
    />
  );
};

export default DifmButtonContainer;
